module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAUBJREFUOI2VlduRgzAMRU8IHezW4PSQGuIetgf3sH8UkDqghu1h6SE95MPWRCiSIZphDEJcSVcPTvQltTMr3X87l96Hpw5gVsAAq3EGMEdORgf0piKcDGhk54Jb43s7j4r7zWgMMjU97d3SslJ5Fhs5s34+74DegB/gAfw10G/gqpzoM7f7h03HSkRL6dgXgEF5mo1RIpY5sJmaLg0qoqiqXkfsyrBv4kauC+kFkQfgEkS1tiuz5Vm6xFK3AfcGRMtELUZmOwwrOwMhwL1CTWwjlkwiScA8UlMqTeHtA3gH2nv/RoWd/09Ec77IdisqkpW4MJ4kagNIFjOwjOqhqPtPelc4L1o5qJfRNB2RTbTwWkICDi+Oj0btLrCzMdLgPQcJ+AJ+qfzarRj+mqRv7VAIqNa5NYmAPScXpZN6hHQ9AZFmUqeHpJR0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginusername.png
// module id = kitK
// module chunks = 1